
import React from "react";

interface ImagePreviewProps {
  imagePreview: string | null;
  onError: () => void;
}

export function ImagePreview({ imagePreview, onError }: ImagePreviewProps) {
  if (!imagePreview) return null;
  
  return (
    <div className="mt-2">
      <img 
        src={imagePreview} 
        alt="Προεπισκόπηση" 
        className="w-full max-h-48 object-cover rounded-md" 
        onError={onError}
      />
    </div>
  );
}
